export default __webpack_public_path__ + "static/media/knock.ceac8e4a.svg";